/**
 * Mock categories taken from .product/content/categories.md.
 * 8 parent buckets + 25 top-level categories.
 */

import type { Category } from '@/types/domain';

export const mockParentBuckets: Category[] = [
  { id: 101, slug: 'g_home', name_ua: 'Дім', icon: '🏠', parent_id: null },
  { id: 102, slug: 'g_beauty', name_ua: 'Краса і фітнес', icon: '💇', parent_id: null },
  { id: 103, slug: 'g_education', name_ua: 'Освіта і мови', icon: '🎓', parent_id: null },
  { id: 104, slug: 'g_legal_fin', name_ua: 'Право і фінанси', icon: '⚖️', parent_id: null },
  { id: 105, slug: 'g_health', name_ua: "Здоров'я і діти", icon: '🏥', parent_id: null },
  { id: 106, slug: 'g_transport', name_ua: 'Авто і логістика', icon: '🚗', parent_id: null },
  { id: 107, slug: 'g_creative', name_ua: 'IT і креатив', icon: '💻', parent_id: null },
  { id: 108, slug: 'g_events', name_ua: 'Події і нерухомість', icon: '🎉', parent_id: null },
];

export const mockCategories: Category[] = [
  { id: 1, slug: 'repair', name_ua: 'Ремонт і будівництво', icon: '🛠', parent_id: 101 },
  { id: 2, slug: 'beauty', name_ua: 'Краса і догляд', icon: '💇', parent_id: 102 },
  { id: 3, slug: 'legal', name_ua: 'Юридичні послуги', icon: '⚖️', parent_id: 104 },
  { id: 4, slug: 'tutoring', name_ua: 'Репетитори', icon: '🎓', parent_id: 103 },
  { id: 5, slug: 'childcare', name_ua: 'Догляд за дітьми', icon: '👶', parent_id: 105 },
  { id: 6, slug: 'translation', name_ua: 'Переклад', icon: '🌐', parent_id: 103 },
  { id: 7, slug: 'it', name_ua: 'IT і веб', icon: '💻', parent_id: 107 },
  { id: 8, slug: 'auto', name_ua: 'Авто і транспорт', icon: '🚗', parent_id: 106 },
  { id: 9, slug: 'medicine', name_ua: "Здоров'я", icon: '🏥', parent_id: 105 },
  { id: 10, slug: 'psychology', name_ua: 'Психологія', icon: '🧠', parent_id: 105 },
  { id: 11, slug: 'real_estate', name_ua: 'Нерухомість', icon: '🏠', parent_id: 108 },
  { id: 12, slug: 'photo_video', name_ua: 'Фото і відео', icon: '📷', parent_id: 107 },
  { id: 13, slug: 'cleaning', name_ua: 'Прибирання', icon: '🧹', parent_id: 101 },
  { id: 14, slug: 'catering', name_ua: 'Кулінарія', icon: '🍰', parent_id: 108 },
  { id: 15, slug: 'weddings', name_ua: 'Весілля', icon: '💍', parent_id: 108 },
  { id: 16, slug: 'fitness', name_ua: 'Спорт і фітнес', icon: '💪', parent_id: 102 },
  { id: 17, slug: 'music', name_ua: 'Музика і творчість', icon: '🎵', parent_id: 103 },
  { id: 18, slug: 'courier', name_ua: "Кур'єри і доставка", icon: '📦', parent_id: 106 },
  { id: 19, slug: 'moving', name_ua: 'Переїзд', icon: '📋', parent_id: 101 },
  { id: 20, slug: 'accounting', name_ua: 'Бухгалтерія', icon: '📊', parent_id: 104 },
  { id: 21, slug: 'design', name_ua: 'Дизайн', icon: '🎨', parent_id: 107 },
  { id: 22, slug: 'copy', name_ua: 'Копірайтинг', icon: '✍️', parent_id: 107 },
  { id: 23, slug: 'flowers', name_ua: 'Флористика', icon: '💐', parent_id: 108 },
  { id: 24, slug: 'pets', name_ua: 'Тварини', icon: '🐾', parent_id: 101 },
  { id: 25, slug: 'other', name_ua: 'Інше', icon: '⭐', parent_id: 108 },
];
